import { Dispatch, SetStateAction } from 'react';
import { RecommendationPayload, RecommendationType, RecommendationResponse } from '../types/common';
import { boughTogetherRecommendations } from './recommendations/boughTogetherRecommendations';
import { brandAndCategoryRecommendationProducts } from './recommendations/brandAndCategoryRecommendationProducts';
import { curatedRecommendations } from './recommendations/curatedRecommendations';
import { homeRecommendationProducts } from './recommendations/homeRecommendations';
import { fetchSearchCarouselRecommendations } from './recommendations/searchCarouselRecommendations';

export const getRecommendations = async (
  payload: RecommendationPayload,
  setIsLoading?: Dispatch<SetStateAction<boolean>>,
  setIsProductApiLoading?: Dispatch<SetStateAction<boolean>>,
  onDataUpdate?: (data: RecommendationResponse) => void,
  isPromoTagV2Enabled?: boolean,
  mmid?: string,
  isNative?: boolean,
) => {
  try {
    const { type } = payload;
    const recommendationData: RecommendationResponse = {
      products: [],
      actualCount: 0,
      totalCount: 0,
      recommendationType: '',
      algorithm: '',
    };
    const assignRecommendationData = (rProducts: RecommendationResponse) => {
      recommendationData.products = rProducts?.products ?? [];
      recommendationData.actualCount = rProducts?.actualCount ?? 0;
      recommendationData.totalCount = rProducts?.totalCount ?? 0;
      recommendationData.recommendationType = rProducts?.recommendationType ?? '';
      recommendationData.algorithm = rProducts?.algorithm ?? '';
      recommendationData.personalised = rProducts?.personalised;
      onDataUpdate?.(recommendationData);
      return recommendationData;
    };

    switch (type) {
      case RecommendationType.BRANDS:
      case RecommendationType.CATEGORIES: {
        const rProducts = await brandAndCategoryRecommendationProducts(payload, assignRecommendationData, mmid);
        return assignRecommendationData(rProducts);
      }
      case RecommendationType.BOUGHTTOGETHER: {
        const rProducts = await boughTogetherRecommendations(payload, assignRecommendationData, mmid);
        return assignRecommendationData(rProducts);
      }
      case RecommendationType.TOPPICKS:
      case RecommendationType.SEARCH_START_TOP_PICKS:
      case RecommendationType.FRESHFOOD:
      case RecommendationType.BASKET_RECOMMENDATION:
      case RecommendationType.BUY_AGAIN:
      case RecommendationType.HOME_RECOMMENDATIONS: {
        const rProducts = await homeRecommendationProducts(
          payload,
          setIsLoading,
          setIsProductApiLoading,
          assignRecommendationData,
          isPromoTagV2Enabled,
          mmid,
          isNative,
        );
        return assignRecommendationData(rProducts);
      }
      case RecommendationType.AGEING_RECOMMENDATIONS:
      case RecommendationType.NEW_ARRIVALS_RECOMMENDATIONS: {
        const allowAlcohol = type === RecommendationType.NEW_ARRIVALS_RECOMMENDATIONS ? true : false;
        const rProducts = await fetchSearchCarouselRecommendations(
          payload,
          allowAlcohol,
          assignRecommendationData,
          mmid,
        );
        return assignRecommendationData(rProducts);
      }
      case RecommendationType.ADSCAROUSEL: {
        if (payload.searchRequest?.q?.length !== 0) {
          const rProducts = await curatedRecommendations(
            {
              includeCurations: true,
              ...payload,
            },
            assignRecommendationData,
            mmid,
          );
          return assignRecommendationData(rProducts);
        } else {
          return recommendationData;
        }
      }
      default: {
        console.warn(`Unsupported recommendation type: ${type}`);
        return recommendationData;
      }
    }
  } catch {
    return {
      products: [],
      actualCount: 0,
      totalCount: 0,
      recommendationType: '',
      algorithm: '',
    };
  }
};
